module.exports = __webpack_public_path__ + "img/hr-green-pita-14.2cdc3913.png";